import { useCallback } from "react";
import { Button } from "~/components/ui/button";
import { IoClose } from "react-icons/io5";
import { Dialog, DialogClose, DialogContent } from "~/components/ui/dialog";
import { LoginFlow } from "~/components/common/LoginForms";
import loginGoodsImg from "~/assets/login-goods.svg";
import loginBirbyLeftImg from "~/assets/login-birby-left.svg";

export default function Login({
  open,
  onOpenChange,
  onSuccess,
  initialEmail,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSuccess?: () => void;
  initialEmail?: string;
}) {
  const onLoginSuccess = useCallback(() => {
    if (onSuccess) {
      onSuccess();
    }
    onOpenChange(false);
  }, [onSuccess, onOpenChange]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        id="login-dialog"
        className="bg-opacity-0 overflow-hidden border-none shadow-none sm:max-w-none"
        showCloseButton={false}
      >
        <div className="mx-auto flex max-h-[752px] max-w-[1025px] flex-col items-center justify-center gap-[16px] overflow-hidden lg:h-[752px] lg:w-[1025px]">
          <div id="close-button" className="flex w-full justify-end">
            <DialogClose asChild>
              <Button
                id="login-close-button"
                variant="ghost"
                size="icon"
                className="rounded-[12px] border-[1px] border-[rgba(255,255,255,0.1)] bg-[rgba(255,255,255,0.1)] p-[8px] hover:bg-[rgba(255,255,255,0.2)]"
              >
                <IoClose className="text-[16px] text-white" />
              </Button>
            </DialogClose>
          </div>

          <div className="mx-auto flex max-h-[607px] max-w-[1025px] flex-row overflow-hidden lg:h-[607px] lg:w-[1025px]">
            <div className="max-w-[504px] overflow-hidden rounded-l-[48px] bg-[#FFFFFF] max-sm:hidden lg:w-[504px]">
              <div className="flex h-full flex-col items-center justify-between pt-[75px]">
                <img src={loginGoodsImg} alt="Goods" className="h-[329px] w-[326px]" />
                <img src={loginBirbyLeftImg} alt="Birby" className="w-[367px]" />
              </div>
            </div>
            <div className="w-[17px] bg-[#FFFFFF] max-sm:hidden" />
            <div className="max-w-[504px] overflow-hidden bg-[#FFFFFF] p-[12px] max-sm:rounded-[24px] max-sm:bg-white sm:rounded-r-[48px] lg:w-[504px] lg:p-[16px]">
              <div className="flex h-full flex-col items-center justify-center bg-[#FFFEEE]">
                <div className="flex max-h-[436px] max-w-[344px] flex-col items-center justify-center gap-[25px] lg:h-[436px] lg:w-[344px]">
                  <LoginFlow
                    onSuccess={onLoginSuccess}
                    initialEmail={initialEmail}
                    title="Welcome to Blidz!"
                    subtitle="Please enter your detail"
                    className="w-full"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
